import React from "react";
import { ColumnFilter, ColumnSort } from "@tanstack/react-table";
import GridTableCommon from "../../GridTableCommon/GridTableCommon";

interface SeriesDataTableProps {
  appDetails?: {
    columns: Array<{ name: string; id: string; type: string }>;
    totalCount: number;
    rows: Array<Record<string, any>>;
  };
  isLoading?: boolean;
  filters: ColumnFilter[];
  setFilters: (filters: ColumnFilter[]) => void;
  sorting: ColumnSort[];
  setSorting: (sorting: ColumnSort[]) => void;
  pagination: { page: number; rowsPerPage: number };
  setPagination: (pagination: { page: number; rowsPerPage: number }) => void;
}

const SeriesDataTable = ({
  appDetails,
  isLoading = false,
  filters,
  setFilters,
  sorting,
  setSorting,
  pagination,
  setPagination,
}: SeriesDataTableProps) => {
  // const filteredData: any[] = useMemo(() => {
  //   dispatch(setAppliedSeriesInlineFilters(filters || []));
  //   return filterDataByAPI(sortData(appDetails?.rows ?? [], sorting), filters || []);
  // }, [appDetails?.rows, filters, sorting, dispatch]);

  // const gridData = useMemo(() => {
  //   const columns = (appDetails?.columns ?? []).map((col) => ({
  //     id: col.id,
  //     name: col.name,
  //   }));

  //   return {
  //     columns,
  //     rows: filteredData,
  //     totalCount: filteredData.length,
  //   };
  // }, [appDetails?.columns, filteredData]);

  return (
    <div>
      {/* {!appDetails ? (
        <div style={{ width: "100%" }}>
          <NotificationToast
            severity="error"
            title="Error"
            message="There was an issue loading the data. If this error persists, please contact the iTX team."
            handleClose={() => {}}
            width="100%"
          />
        </div>
      ) : ( */}
      <GridTableCommon
        gridData={appDetails ?? {}}
        selectedRows={[]}
        onSelectionChange={() => {}}
        isRowValid={() => false}
        keyId="app_name"
        title="Application Summary"
        loading={isLoading}
        filters={filters}
        sorting={sorting}
        setSorting={setSorting}
        setFilters={setFilters}
        onRowClick={() => {}}
        pagination={pagination}
        setPagination={setPagination}
        hideSelectionBar={true}
        hideSelectionCaret={true}
        style={{
          height: "calc(100vh - 24rem)",
          maxWidth: "calc(100vw - 4rem)",
        }}
      />
      {/* )} */}
    </div>
  );
};

export default SeriesDataTable;
